/**
 * @generated SignedSource<<a23b6bdf682e0e511c55282d3f847f86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type WidgetIssueSummaryIssueChangedSubscription$variables = {
  teamIds: ReadonlyArray<string>;
};
export type WidgetIssueSummaryIssueChangedSubscription$data = {
  readonly issueStatusChanged: {
    readonly store: {
      readonly teams: ReadonlyArray<{
        readonly unresolvedIssueCount: number;
      }>;
    };
  } | null;
};
export type WidgetIssueSummaryIssueChangedSubscription = {
  response: WidgetIssueSummaryIssueChangedSubscription$data;
  variables: WidgetIssueSummaryIssueChangedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "teamIds",
    "variableName": "teamIds"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "teamIds"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unresolvedIssueCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetIssueSummaryIssueChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Issue",
        "kind": "LinkedField",
        "name": "issueStatusChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WidgetIssueSummaryIssueChangedSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Issue",
        "kind": "LinkedField",
        "name": "issueStatusChanged",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Store",
            "kind": "LinkedField",
            "name": "store",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0bc81d537a985fe3f21486662f49a1fe",
    "id": null,
    "metadata": {},
    "name": "WidgetIssueSummaryIssueChangedSubscription",
    "operationKind": "subscription",
    "text": "subscription WidgetIssueSummaryIssueChangedSubscription(\n  $teamIds: [ID!]!\n) {\n  issueStatusChanged(teamIds: $teamIds) {\n    store {\n      teams(ids: $teamIds) {\n        unresolvedIssueCount\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "81db329b6cc0c99bbf78b0247eed7257";

export default node;
